import React, { useEffect, useState } from "react";

import fileDownload from "js-file-download";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";

import URL from "../../../config/api";
import axios from "../../../config/axios";
import { ContentCard } from "../../ContentCard";
import Loading from "../../Loading";

// Modal do "Visualizar" de uma atividade sugerida: série, disciplinas e os
// conteúdos da atividade, cada um abrindo no seu destino.
//
// `activity` é o registro enxuto que activity/activity/listByAbility devolve
// (id/name/serie_name/discipline_name) — quem chama guarda qual está aberta e
// fecha pelo `onClose`. Os itens não vêm nele, então são buscados no singleView
// quando a modal abre.
export default function ActivityViewModal({ activity, onClose }) {
  const token = useSelector(state => state.user.token);

  const [activityDetail, setActivityDetail] = useState(null);

  useEffect(() => {
    if (!activity) return;

    // Limpa o detalhe da anterior: sem isso a modal abriria mostrando os
    // conteúdos da atividade que foi visualizada antes desta.
    setActivityDetail(null);

    axios
      .get(`${URL.api}activity/activity/singleView/${activity.id}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(response => {
        setActivityDetail(response.data.data);
      })
      .catch(() => {
        toastr.error("Falha", "Não foi possível carregar a atividade.");
      });
  }, [activity?.id]);

  const openItem = itemAux => {
    switch (itemAux.type_id) {
      case 12: // Lista de exercícios
        window.open(`/activity/show/${itemAux.activity_id}`, "_blank").focus();
        break;

      case 14: // Literarte
        break;

      case 27: // Link
      case 16:
        window.open(itemAux.content_path, "_blank").focus();
        break;

      case 17: // Arquivo
        {
          const downloadPath = itemAux.link
            ? itemAux.link.substring(itemAux.link.indexOf("uploads/") + 8)
            : `${itemAux.obj_id === 1 ? "activity" : "repo"}/${itemAux.name}`;

          axios
            .get(`${URL.api}download/${downloadPath}`, {
              headers: { authorization: `Bearer ${token}` },
              responseType: "blob"
            })
            .then(resp => {
              fileDownload(resp.data, itemAux.name);
            });
        }
        break;

      default:
        axios
          .get(`${URL.api}content/los/singleView/${itemAux.obj_id}`, {
            headers: { authorization: `Bearer ${token}` }
          })
          .then(
            resp => {
              const contentData = resp.data.data;
              window
                .open(
                  `/content/view/${contentData.id}?title=${contentData.name}`,
                  "_blank"
                )
                .focus();
            },
            () => {
              toastr.error(
                "Falha",
                "Não foi possível abrir o link. Tente novamente!"
              );
            }
          );
        break;
    }
  };

  /* O xl deixa a modal larga — e faz o breakpoint xl das colunas valer, então
     os cards cabem três por linha. O `scrollable` faz o corpo rolar quando a
     lista de conteúdos passa da altura da tela, em vez de ser cortada, e o pb-4
     evita que o último card encoste na borda de baixo. */
  return (
    <Modal isOpen={!!activity} toggle={onClose} size="xl" scrollable>
      <ModalHeader toggle={onClose}>{activity?.name}</ModalHeader>
      <ModalBody className="pb-4">
        {!activityDetail ? (
          <Loading />
        ) : (
          <>
            <div>
              <strong>Série: </strong>
              {activityDetail.serie_name}
            </div>
            <div>
              <strong>Disciplinas: </strong>
              {activityDetail.discipline_name}
            </div>
            <Row>
              {activityDetail.items?.map(item => (
                <Col xs="12" md="6" xl="4" key={item.id}>
                  <ContentCard.Root height="auto">
                    <ContentCard.Banner
                      fallbackColor={item.type_color}
                      fallbackIcon={item.type_icon}
                      actions={
                        item.type_id !== 10 &&
                        item.type_id !== 14 &&
                        item.type_id !== 15 && [
                          {
                            title: "Abrir conteúdo",
                            icon: "external-link",
                            action: () => openItem(item)
                          }
                        ]
                      }
                      height="108px"
                    />
                    <ContentCard.Main>
                      <ContentCard.Header
                        title={item.name}
                        description={item.type_name}
                      />
                    </ContentCard.Main>
                  </ContentCard.Root>
                </Col>
              ))}
            </Row>
          </>
        )}
      </ModalBody>
    </Modal>
  );
}
